import { BsCheckCircleFill } from "react-icons/bs";

const successMessage = (msg) => ({
    render: msg,
    type: "success",
    icon: <BsCheckCircleFill />,
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    className: "custom-toast-success",
});

export default successMessage;